import React from 'react'
import styles from './styles.module.css'


export default function Main() {

    return (
        <div className={styles.wrapper}>
            <h1>Главная</h1>
        </div>
    )
}
